<template>
	<v-row class="bg-transparent p-absolute ma-0 my-2 pa-0 px-0 saldo__text full-width d-flex flex-nowrap" style="bottom: 0;
	z-index: 2">
		<v-container class="ma-0 pa-0 pr-2 d-flex justify-end align-center" style="min-width: 160px; max-width: 160px">
			Animais Alojados
		</v-container>
		<v-col class="ma-0 pa-0 d-flex align-end" v-for="(_, idx) in listaDatas" :key="idx" style="min-width: 162px;
		max-width: 400px;">
			<v-row class="ma-0 pa-0 d-flex align-end">
				<!-- Machos			-->
				<saldo-alocado-dia :key="`${crechario.cdLoteProducaoCreche}_${crechario.cdCrecheSemLote}_${idx + 1}_Machos`"
				                   :dia="idx + 1" :lotesCrecheDia="lotesCrecheDia(idx + 1)" genero="Machos"
				                   :crechario="crechario" :nrDias="listaDatas.length" />
				<!-- Fêmeas			-->
				<saldo-alocado-dia :key="`${crechario.cdLoteProducaoCreche}_${crechario.cdCrecheSemLote}_${idx + 1}_Femeas`"
				                   :dia="idx + 1" :lotesCrecheDia="lotesCrecheDia(idx + 1)" genero="Femeas"
				                   :crechario="crechario" :nrDias="listaDatas.length"
				/>
<!--				v-if="crechario[`qtFemeasDia${idx + 1}`] > 0"-->
			</v-row>
		</v-col>
		<v-container style="width: 20px" />
	</v-row>
</template>
<script>
import SaldoAlocadoDia from "./SaldoAlocadoDia";
import {mapState} from "vuex";

export default {
	name: 'SaldoAlocadoCrechario',
	components: {SaldoAlocadoDia},
	computed: {
		...mapState("planejamentoAlojamento", ["listaLotesAlocados"]),
		lotesCrecheDia: () => {
			return function (dia) {
				if (this.listaLotesAlocados.length === 0) return []

				return this.listaLotesAlocados.filter(lote => {
					return lote.cdCrecheSemLote === this.crechario.cdCrecheSemLote &&
							lote.cdLoteProducaoCreche === this.crechario.cdLoteProducaoCreche &&
							lote.stDiaAlocado === `qtDia${dia}`
				})
			}
		},
	},
	props: {
		crechario: {
			type: Object,
			required: true,
		},
		listaDatas: {
			type: Array,
			required: true,
		},
	}
}
</script>
